import { render, staticRenderFns } from "./AddClientIcon.vue?vue&type=template&id=1cfac1db&scoped=true&"
import script from "./AddClientIcon.vue?vue&type=script&lang=js&"
export * from "./AddClientIcon.vue?vue&type=script&lang=js&"
import style0 from "./AddClientIcon.vue?vue&type=style&index=0&id=1cfac1db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfac1db",
  null
  
)

export default component.exports